module.exports = __webpack_public_path__ + "img/image04_sp.ba3db77e.jpg";